/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.proveedores': 'Proveedores',
  'proveedores.agregarProveedores': 'Crear Proveedores',
  'proveedores.modificarProveedores': 'Editar Proveedores',
  'proveedores.proveedorId': 'Proveedor Id',
  'proveedores.empresaId': 'Empresa Id',
  'proveedores.descripcionProveedor': 'Descripción Proveedor',
  'proveedores.VerProveedores': 'Ver Proveedores',
};
